import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { ISelectOption, SelectField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const BillingPeriod: React.FC<IFieldProps> = ({ baseName, readOnly }) => {
  const options: ISelectOption<string>[] = ['Annual', 'Semi Annual', 'Quarterly', 'Monthly'].map((t) => ({
    label: t,
    value: t,
  }));
  return (
    <SelectField
      label={'Billing Period'}
      name={`${baseName}.stringFeePropertyValues.${eFeePropertyNames.BillingPeriod}`}
      options={options}
      isClearable
      isDisabled={readOnly}
    />
  );
};
